import { Injectable } from '@angular/core';
import { BooxCookieService } from './boox-cookie.service';
import { BooxSessionService } from './boox-session.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BooxBootService {

  constructor(
    private cookie : BooxCookieService,
    private session : BooxSessionService,
  ) { }

  async load() {

    const promises: Promise<boolean>[] = [];
    /**
     * Seems that auth promise (and probably others later) relies on having env loaded
     * So running it on parallel delivers unwanted/unexpected results sometimes
     * Therefore I can have it resolved sequentially before the others do it in parallel
     */
    await this.loadEnv();
    await this.loadSession();

    // promises.push(this.loadExample());
    // promises.push(this.loadLanguage());

    await Promise.all(promises);
  }

  /**
   *
   * @returns {Promise}
   */
  private async loadEnv() : Promise<boolean> {
    return true;
  }

  /**
   *
   * @returns {Promise}
   */
  private async loadSession() : Promise<boolean> {
    try{
      await firstValueFrom(this.session.load());
    }
    catch(e){}
    return true;
  }

  /**
   *
   * @returns {Promise}
   */
  // private loadExample () {
  //   return new Promise((_resolve, _reject) => {
  //     _resolve(true);
  //   });
  // }

  /**
   *
   * @returns {Promise}
   */
  // private loadLanguage () {
  //   return new Promise((resolve, reject) => {
  //     this.languageServ.loadFromCookie() || this.languageServ.loadFromBrowser() || this.languageServ.loadDefault();
  //     resolve(true);
  //   });
  // }
}
